import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Table, Button, Container } from 'react-bootstrap';
import HeaderAdmin from "../../HeaderAdmin";

const DistrictWise = () => {
  const location = useLocation();
  // Accept state from location.state or fallback to localStorage
  const stateName = location.state?.state ||  '';
  const [districtArray, setDistrictArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetch('https://ecoclubs.education.gov.in/api/ekped-allrecords', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ state: stateName }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          // Parse district data
          const parsed = Object.keys(data)
            .filter(key => !isNaN(Number(key)))
            .map(key => data[key])
            .sort((a, b) => a.district.localeCompare(b.district));
          setDistrictArray(parsed);
        } else {
          setError('Failed to fetch data');
        }
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to fetch data');
        setLoading(false);
      });
  }, [stateName]);

  if (loading) return <div style={{textAlign: 'center', marginTop: 40}}><h3>Loading...</h3></div>;
  if (error) return <div style={{textAlign: 'center', marginTop: 40, color: 'red'}}>{error}</div>;
  let total=0;

  return (
    <>
    <HeaderAdmin />
    <Container style={{
        marginTop:"50px",
        marginBottom:"50px"
    }}>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>District</th>
            <th>Saplings Planted</th>
            <th>Total Schools</th>
            {/* <th>Action</th> */}
          </tr>
        </thead>
        <tbody>
          {districtArray.map((item, idx) => (
            total += item.studentCount,
            <tr key={item.district}>
              <td>{idx + 1}</td>
              <td>{item.district}</td>
              <td>{item.studentCount}</td>
              <td>{item.totalSchools}</td>
              
            </tr>
          ))}
          
        </tbody>
      </Table>
    </Container>
    </>
  );
};

export default DistrictWise;
